import { render, staticRenderFns } from "./bspdevreraporu.vue?vue&type=template&id=82e4703c&"
import script from "./bspdevreraporu.vue?vue&type=script&lang=js&"
export * from "./bspdevreraporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports